import { AuthorizationGrantScope, type MyAuthorizationQuery } from "@/graphql";

export type AuthorizationSnapshot = MyAuthorizationQuery["MyAuthorization"];

export function hasRightInSnapshot(
  snapshot: AuthorizationSnapshot | null,
  right: string,
  siteId?: number | null,
): boolean {
  const grant = snapshot?.grants.find((entry) => entry.name === right);
  if (!grant) return false;
  if (grant.scope === AuthorizationGrantScope.INSTANCE) return true;
  if (!Number.isInteger(siteId) || (siteId ?? 0) <= 0) return false;
  if (grant.scope === AuthorizationGrantScope.ALL_SITES) return true;
  return grant.siteIds.includes(siteId!);
}

export function hasRightOnAnySiteInSnapshot(
  snapshot: AuthorizationSnapshot | null,
  right: string,
): boolean {
  const grant = snapshot?.grants.find((entry) => entry.name === right);
  return Boolean(
    grant &&
    (grant.scope === AuthorizationGrantScope.INSTANCE ||
      grant.scope === AuthorizationGrantScope.ALL_SITES ||
      grant.siteIds.length > 0),
  );
}
